import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=2b3af882&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=ts&"
export * from "./Step5.vue?vue&type=script&lang=ts&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=2b3af882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3af882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3af882')) {
      api.createRecord('2b3af882', component.options)
    } else {
      api.reload('2b3af882', component.options)
    }
    module.hot.accept("./Step5.vue?vue&type=template&id=2b3af882&scoped=true&", function () {
      api.rerender('2b3af882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/Step5.vue"
export default component.exports